<script setup lang="ts">
import { computed } from 'vue'
import ShellFooterLinks from './ShellFooterLinks.vue'
import ShellFooterLegal from './ShellFooterLegal.vue'
const route = useRoute()
// Prototype pages with a footer, plus public SEO landings retaining their link set.
const visible = computed(() => !/^\/(create|library|me|feed|checkout|payment|billing|album-cover\/|clips\/)/.test(route.path))
</script>
<template><footer v-if="visible" class="foot shell-footer mm-root"><div class="wrap"><ShellFooterLinks /><ShellFooterLegal /></div></footer></template>

<style scoped>
/* H5 uses the tab bar and Me links; keep this rule on every footer mount. */
@media (max-width: 1023px) {
  .shell-footer { display: none; }
}
</style>
